import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const InboundIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0558 3.50751C10.935 3.39814 10.7761 3.34032 10.6132 3.34638C10.4503 3.35244 10.2962 3.42192 10.1838 3.53998C10.0714 3.65804 10.0096 3.81534 10.0115 3.97835C10.0135 4.14135 10.079 4.29715 10.1942 4.41251L15.4033 9.37501H3.125C2.95924 9.37501 2.80027 9.44086 2.68306 9.55807C2.56585 9.67528 2.5 9.83425 2.5 10C2.5 10.1658 2.56585 10.3247 2.68306 10.442C2.80027 10.5592 2.95924 10.625 3.125 10.625H15.4033L10.1942 15.5867C10.074 15.7009 10.0042 15.8582 10.0001 16.024C9.99595 16.1897 10.0578 16.3503 10.1721 16.4704C10.2863 16.5906 10.4436 16.6604 10.6094 16.6645C10.7751 16.6686 10.9357 16.6068 11.0558 16.4925L17.2392 10.6033C17.3742 10.4748 17.4623 10.3046 17.4892 10.12C17.5036 10.0401 17.5033 9.95818 17.4883 9.87835C17.4611 9.6944 17.3731 9.52485 17.2383 9.39668L11.0558 3.50751Z"
        fill="currentColor"
      />
    </svg>
  </SvgIcon>
)

export default InboundIcon
